import React, { useEffect } from 'react'
import "./receipt.css"
import { Button } from '@mui/material'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link, useNavigate } from 'react-router-dom';
import WhatsAppChatBtn from '../../components/whatsAppChatBtn/WhatsAppChatBtn';
import { useSelector } from 'react-redux';
import axios from 'axios';

function Receipt({}) {
  const navigate = useNavigate()
  const payent_id = localStorage.getItem("payent_id");



  return (
    <div className='receipt'>
    <Button onClick={()=> navigate(-1)} className='btn back'>
        <KeyboardReturnIcon className='back-icon'/>
    </Button>
         <div id="invoice-POS">
    
    <center id="top">
      <div class="logo"></div>
      <div class="info"> 
        <h2>dsasimplified.com</h2>
      </div>
    </center>
    
    <div id="mid">
      <div class="info">
        <h2>Contact Info</h2>
        <p> 
            Email   : gta.support@gmail.com<br/>
            Phone   : +91 60011 17920<br/>
        </p>
      </div>
    </div>
    <div id="mid">
      <div class="info">
        <h2>Transaction Detail</h2>
        <p> 
            {/* Address : street city, state 0000<br/> */}
            Payment ID   : {payent_id || "Err"}<br/>
        </p>
      </div>
    </div>
    
    <div id="bot">

					<div id="table">
						<table>
							<tr class="tabletitle">
								<td class="item"><h2>Description</h2></td>
								<td class="Rate"><h2>Sub Total</h2></td>
							</tr>

							<tr class="service">
								<td class="tableitem"><p class="itemtext">150 DSA patterns</p></td>
								<td class="tableitem"><p class="itemtext">₹ 3,000</p></td>
							</tr>

							<tr class="service">
								<td class="tableitem"><p class="itemtext">Discount</p></td>
								<td class="tableitem"><p class="itemtext">₹ -2,701</p></td>
							</tr>

							

							<tr class="tabletitle">
								<td class="Rate"><h2>Total</h2></td>
								<td class="payment"><h2>₹ 299</h2></td>
							</tr>

						</table>
					</div>

					<div id="legalcopy">
						<p class="legal"><strong>Thank you for subscribing! </strong>  
						</p>
					</div>
                    
				</div>
        <div style={{marginTop: "25px"}}>
        <WhatsAppChatBtn />   
        </div>
             
  </div>
    </div>
  )
}

export default Receipt